import { BrowserRouter, Route, Routes } from 'react-router';
import { AuthLayout } from './Layout/Auth.Layout';
import { LoginPage } from './Pages/Login.page';
import { useLoginContext } from './Contexts/Login.Context';

export const AppRouter = () => {
  const { token } = useLoginContext();
  return (
    <BrowserRouter>
      <Routes>
        {!token ? <Route path="*" element={<LoginPage />} /> : <Route path="*" element={<AuthLayout />} />}
      </Routes>
    </BrowserRouter>
  );
};
